module.exports = __webpack_public_path__ + "static/media/ban.2fc355be.jpg";